/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "Publicodes",
  "tagline": "Le langage pour les algorithmes d'intérêt public",
  "url": "https://publi.codes",
  "baseUrl": "/",
  "onBrokenLinks": "warn",
  "onBrokenMarkdownLinks": "warn",
  "favicon": "img/favicon-32x32.png",
  "organizationName": "betagouv",
  "projectName": "publicodes",
  "themes": [
    "@docusaurus/theme-live-codeblock"
  ],
  "themeConfig": {
    "navbar": {
      "title": "Publicodes",
      "logo": {
        "alt": "Publicodes logo",
        "src": "img/logo-publicodes.svg"
      },
      "items": [
        {
          "type": "doc",
          "docId": "principes-de-base",
          "position": "left",
          "label": "Documentation"
        },
        {
          "to": "studio",
          "position": "left",
          "label": "Bac à sable"
        },
        {
          "href": "https://pad.incubateur.net/s/qTHaJc9VH#",
          "label": "📅 Meetup Publicodes à Paris ",
          "position": "right"
        },
        {
          "href": "https://github.com/betagouv/publicodes",
          "label": "GitHub",
          "position": "right"
        }
      ],
      "hideOnScroll": false
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#bfc7d5",
          "backgroundColor": "#292d3e"
        },
        "styles": [
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(105, 112, 152)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "string",
              "inserted"
            ],
            "style": {
              "color": "rgb(195, 232, 141)"
            }
          },
          {
            "types": [
              "number"
            ],
            "style": {
              "color": "rgb(247, 140, 108)"
            }
          },
          {
            "types": [
              "builtin",
              "char",
              "constant",
              "function"
            ],
            "style": {
              "color": "rgb(130, 170, 255)"
            }
          },
          {
            "types": [
              "punctuation",
              "selector"
            ],
            "style": {
              "color": "rgb(199, 146, 234)"
            }
          },
          {
            "types": [
              "variable"
            ],
            "style": {
              "color": "rgb(191, 199, 213)"
            }
          },
          {
            "types": [
              "class-name",
              "attr-name"
            ],
            "style": {
              "color": "rgb(255, 203, 107)"
            }
          },
          {
            "types": [
              "tag",
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 114)"
            }
          },
          {
            "types": [
              "operator"
            ],
            "style": {
              "color": "rgb(137, 221, 255)"
            }
          },
          {
            "types": [
              "boolean"
            ],
            "style": {
              "color": "rgb(255, 88, 116)"
            }
          },
          {
            "types": [
              "keyword"
            ],
            "style": {
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "doctype"
            ],
            "style": {
              "color": "rgb(199, 146, 234)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "color": "rgb(178, 204, 214)"
            }
          },
          {
            "types": [
              "url"
            ],
            "style": {
              "color": "rgb(221, 221, 221)"
            }
          }
        ]
      },
      "additionalLanguages": [],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "footer": {
      "links": [
        {
          "title": "À propos",
          "items": [
            {
              "label": "Statistiques de consultation",
              "to": "/statistiques"
            }
          ]
        }
      ],
      "style": "light"
    },
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": false,
      "respectPrefersColorScheme": false
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "metadata": [],
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    },
    "liveCodeBlock": {
      "playgroundPosition": "bottom"
    }
  },
  "presets": [
    [
      "@docusaurus/preset-classic",
      {
        "docs": {
          "sidebarPath": "/opt/build/repo/website/sidebars.js",
          "editUrl": "https://github.com/betagouv/publicodes/edit/master/website/",
          "remarkPlugins": [
            [
              null,
              {
                "sync": true
              }
            ],
            null
          ]
        },
        "theme": {
          "customCss": "/opt/build/repo/website/src/css/custom.css"
        },
        "pages": {
          "remarkPlugins": [
            null,
            null
          ]
        }
      }
    ]
  ],
  "scripts": [
    "plausible",
    {
      "src": "https://plausible.io/js/plausible.js",
      "data-domain": "publi.codes",
      "defer": true
    }
  ],
  "plugins": [
    "/opt/build/repo/website/src/plugins/studio-route.cjs",
    null
  ],
  "baseUrlIssueBanner": true,
  "i18n": {
    "defaultLocale": "en",
    "path": "i18n",
    "locales": [
      "en"
    ],
    "localeConfigs": {}
  },
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "headTags": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false,
  "markdown": {
    "mermaid": false
  }
};
